import { Moment } from './constructor';

export function clone () {
    return new Moment(this);
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/moment/clone.js